// Modules/Guide/Guide.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import apiService from '../../Utils/APIService';
import { useBrand } from '../../Utils/BrandContext';
import { PACKAGES, getOfferPrice, currPage, PAGE_EDITION_MAPPER } from '../../Constants/Packages';

const Guide = () => {
  const { brand, updateBrand } = useBrand();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  // Fetch lead data
  const fetchLeadData = async (mobile, o) => {
    try {
      const leadResponse = await apiService.getLeadInfo(mobile, o);

      if (leadResponse?.d?.error === false) {
        const updatePackage = JSON.parse(leadResponse.d.updatePackage);
        const leadInfo = updatePackage.info ? JSON.parse(updatePackage.info) : [];
        const leadO = leadInfo[0]?.LeadO || o || '';

        return {
          success: true,
          leadData: updatePackage,
          leadO: leadO,
          mobile: mobile
        };
      } else {
        throw new Error('Failed to fetch lead data');
      }
    } catch (err) {
      console.error('Fetch lead data error:', err);
      throw err;
    }
  };


  const getRedirectPath = (zParam, mobile, o, m, brand, scroll, xParam) => {
    const activeBrand = brand || m || 'qikerp';
    const mQuery = `&m=${activeBrand}`;
    const scrollQuery = scroll ? `&scroll=${scroll}` : '';
    const xQuery = xParam ? `&x=${xParam}` : '';

    const baseUrl = window.location.hostname === 'localhost' ? `http://localhost:${window.location.port}/QikERP` : `${apiService.getBaseUrl()}/QikERP`;

    switch (zParam?.toLowerCase()) {
      case 'intro':
        return `${baseUrl}/Intro?i=${mobile}&o=${o}${mQuery}${scrollQuery}${xQuery}`;
      case 'offer':
        return `${baseUrl}/${currPage}?i=${mobile}&o=${o}${mQuery}&scroll=pricing${xQuery}`;
      case 'question':
        return `https://biziverse.com/Question.html?i=${mobile}&o=${o}${xQuery}`;
      case 'feedback':
      case 'fdbk':
        return `${baseUrl}/FeedBack?i=${mobile}&o=${o}${mQuery}${scrollQuery}${xQuery}`;
      case 'demo':
        return `${baseUrl}/Demo?i=${mobile}&o=${o}${mQuery}${scrollQuery}${xQuery}`;
      case 'main':
      default:
        return `${baseUrl}/${currPage}?i=${mobile}&o=${o}${mQuery}${scrollQuery}${xQuery}`;
    }
  };


  useEffect(() => {
    const fetchAndRedirect = async () => {
      const i = searchParams.get('i'); // mobile
      const o = searchParams.get('o') || ''; // leadid
      const z = searchParams.get('z'); // redirect option
      const m = searchParams.get('m') || ''; // brand option
      const x = searchParams.get('x') || ''; // offer taken
      const dParam = searchParams.get('d') || '';
      const dScrollMap = { '1': 'demo', '4': 'about' };
      const scroll = searchParams.get('scroll') || searchParams.get('s') || dScrollMap[dParam] || ''; // scroll option

      if (m) updateBrand(m);

      if (!i) {
        console.error('Missing mobile parameter');
        window.location.href = '/';
        return;
      }

      try {
        // Fetch lead data
        const result = await fetchLeadData(i, o);

        if (result.success) {
          // IMPORTANT: Set initial data needed by BZPay
          localStorage.setItem('allData', JSON.stringify(result.leadData));
          localStorage.setItem('mySrc', result.leadData.source || 'Guide');

          const cioData = [{
            'i': result.mobile,
            'o': result.leadO,
            'cmp': result.leadData.companyName,
            'name': result.leadData.firstName + ' ' + result.leadData.lastName,
            'eml': result.leadData.email
          }];
          localStorage.setItem('cio', JSON.stringify(cioData));

          const redirectPath = getRedirectPath(z, result.mobile, result.leadO, m, brand || m || 'qik', scroll, x);
          window.location.href = redirectPath;
        } else {
          setError('Failed to load data');
        }
      } catch (err) {
        console.error('Error in Guide:', err);
        setError('Something went wrong');
        // Fallback redirect to main page
        setTimeout(() => {
          const mQuery = m ? `&m=${m}` : '';
          window.location.href = `https://biziverse.com/QikERP/${currPage}?i=${i}&o=${o || ''}${scroll ? `&scroll=${scroll}` : ''}`;
        }, 2000);
      }
    };

    fetchAndRedirect();
  }, [searchParams, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">

      </div>
    </div>
  );
};

export default Guide;